var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isRedirect)?_c('router-link',{attrs:{"to":_vm.toFinal}},[_vm._t("default")],2):_c('a',{attrs:{"href":_vm.href}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }